import _defineProperty from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import React__default from 'react';
import styled from 'styled-components';
import { XIcon } from '@primer/octicons-react';
import { getFocusableChild } from '@primer/behaviors/utils';
import { get } from '../constants.js';
import VisuallyHidden from '../_VisuallyHidden.js';
import sx from '../sx.js';
import { useTheme } from '../ThemeProvider.js';
import { ButtonComponent } from '../Button/Button.js';
import { AnchoredOverlay } from '../AnchoredOverlay/AnchoredOverlay.js';
import Box from '../Box/Box.js';
import { IconButton } from '../Button/IconButton.js';
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var StyledLabelGroupContainer = styled.div.withConfig({
  displayName: "LabelGroup__StyledLabelGroupContainer",
  componentId: "sc-6tqg8q-0"
})(["display:flex;flex-wrap:nowrap;gap:", ";line-height:1;max-width:100%;overflow:hidden;&[data-overflow='inline']{flex-wrap:wrap;}", ";"], get('space.1'), sx);
var ItemWrapper = styled.div.withConfig({
  displayName: "LabelGroup__ItemWrapper",
  componentId: "sc-6tqg8q-1"
})(["display:flex;align-items:center;min-height:28px;&.ItemWrapper--hidden{order:9999;pointer-events:none;visibility:hidden;}"]);

// Calculates the width of the overlay to cover the labels/tokens and the expand button.
var getOverlayWidth = function getOverlayWidth(buttonClientRect, containerRef, overlayPaddingPx) {
  var _containerRef$current, _containerRef$current2;
  return overlayPaddingPx + buttonClientRect.right - (((_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 ? void 0 : (_containerRef$current2 = _containerRef$current.getBoundingClientRect()) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.left) || 0);
};
var InlineToggle = function InlineToggle(_ref) {
  var collapseButtonRef = _ref.collapseButtonRef,
    collapseInlineExpandedChildren = _ref.collapseInlineExpandedChildren,
    expandButtonRef = _ref.expandButtonRef,
    hiddenItemIds = _ref.hiddenItemIds,
    isOverflowShown = _ref.isOverflowShown,
    showAllTokensInline = _ref.showAllTokensInline,
    totalLength = _ref.totalLength;
  return isOverflowShown ? /*#__PURE__*/React__default.createElement(ButtonComponent, {
    ref: collapseButtonRef,
    onClick: collapseInlineExpandedChildren,
    size: "small",
    variant: "invisible"
  }, "Show less") : hiddenItemIds.length ? /*#__PURE__*/React__default.createElement(ButtonComponent, {
    ref: expandButtonRef,
    variant: "invisible",
    size: "small",
    onClick: showAllTokensInline
  }, /*#__PURE__*/React__default.createElement(VisuallyHidden, null, "Show all ", totalLength), /*#__PURE__*/React__default.createElement("span", {
    "aria-hidden": "true"
  }, "+", hiddenItemIds.length)) : null;
};
var OverlayToggle = function OverlayToggle(_ref2) {
  var children = _ref2.children,
    closeOverflowOverlay = _ref2.closeOverflowOverlay,
    expandButtonRef = _ref2.expandButtonRef,
    hiddenItemIds = _ref2.hiddenItemIds,
    isOverflowShown = _ref2.isOverflowShown,
    openOverflowOverlay = _ref2.openOverflowOverlay,
    overlayPaddingPx = _ref2.overlayPaddingPx,
    overlayWidth = _ref2.overlayWidth,
    totalLength = _ref2.totalLength;
  return hiddenItemIds.length ? /*#__PURE__*/React__default.createElement(AnchoredOverlay, {
    open: isOverflowShown,
    onOpen: openOverflowOverlay,
    onClose: closeOverflowOverlay,
    width: "auto",
    height: "auto",
    align: "start",
    side: "inside-right"
    // expandButtonRef satisfies React.RefObject<HTMLButtonElement> because we manually set `.current` in the `useCallback` above
    ,

    anchorRef: expandButtonRef,
    anchorOffset: overlayPaddingPx * -1,
    alignmentOffset: overlayPaddingPx * -1,
    renderAnchor: function renderAnchor(props) {
      return /*#__PURE__*/React__default.createElement(ButtonComponent, _extends({
        variant: "invisible",
        size: "small"
      }, props, {
        ref: expandButtonRef
      }), /*#__PURE__*/React__default.createElement(VisuallyHidden, null, "Show all ", totalLength), /*#__PURE__*/React__default.createElement("span", {
        "aria-hidden": "true"
      }, "+", hiddenItemIds.length));
    },
    focusZoneSettings: {
      disabled: true
    }
  }, /*#__PURE__*/React__default.createElement(Box, {
    alignItems: "flex-start",
    display: "flex",
    width: overlayWidth,
    padding: "".concat(overlayPaddingPx, "px")
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    flexWrap: "wrap",
    sx: {
      gap: 1
    }
  }, children), /*#__PURE__*/React__default.createElement(IconButton, {
    onClick: closeOverflowOverlay,
    icon: XIcon,
    "aria-label": "Close",
    variant: "invisible",
    sx: {
      flexShrink: 0
    }
  }))) : null;
};

// TODO: reduce re-renders
var LabelGroup = function LabelGroup(_ref3) {
  var children = _ref3.children,
    visibleChildCount = _ref3.visibleChildCount,
    _ref3$overflowStyle = _ref3.overflowStyle,
    overflowStyle = _ref3$overflowStyle === void 0 ? 'overlay' : _ref3$overflowStyle,
    sxProp = _ref3.sx;
  var containerRef = React__default.useRef(null);
  var collapseButtonRef = React__default.useRef(null);
  var firstHiddenIndexRef = React__default.useRef(undefined);
  var _React__default$useSt = React__default.useState({}),
    _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
    visibilityMap = _React__default$useSt2[0],
    setVisibilityMap = _React__default$useSt2[1];
  var _React__default$useSt3 = React__default.useState(false),
    _React__default$useSt4 = _slicedToArray(_React__default$useSt3, 2),
    isOverflowShown = _React__default$useSt4[0],
    setIsOverflowShown = _React__default$useSt4[1];
  var _React__default$useSt5 = React__default.useState({
      width: 0,
      right: 0,
      height: 0,
      x: 0,
      y: 0,
      top: 0,
      left: 0,
      bottom: 0,
      toJSON: function toJSON() {
        return undefined;
      }
    }),
    _React__default$useSt6 = _slicedToArray(_React__default$useSt5, 2),
    buttonClientRect = _React__default$useSt6[0],
    setButtonClientRect = _React__default$useSt6[1];
  var _useTheme = useTheme(),
    theme = _useTheme.theme;
  var overlayPaddingPx = parseInt(get('space.2')(theme), 10);
  var hiddenItemIds = Object.keys(visibilityMap).filter(function (key) {
    return !visibilityMap[key];
  });

  // `overlayWidth` is only needed when we render an overlay
  // if we don't use an overlay, we can skip the width calculation
  // and save on reflows caused by measuring DOM nodes.
  var overlayWidth = hiddenItemIds.length && overflowStyle === 'overlay' ? getOverlayWidth(buttonClientRect, containerRef, overlayPaddingPx) : undefined;
  var expandButtonRef = React__default.useCallback(function (node) {
    if (node !== null) {
      var nodeClientRect = node.getBoundingClientRect();
      if (nodeClientRect.width !== buttonClientRect.width || nodeClientRect.right !== buttonClientRect.right) {
        setButtonClientRect(nodeClientRect);
      }

      // @ts-ignore you can set `.current` on ref objects or ref callbacks in React
      expandButtonRef.current = node;
    }
  }, [buttonClientRect]);

  // Sets the visibility map to hide children after the given index.
  var hideChildrenAfterIndex = React__default.useCallback(function (truncateAfter) {
    var _containerRef$current3;
    var containerChildren = ((_containerRef$current3 = containerRef.current) === null || _containerRef$current3 === void 0 ? void 0 : _containerRef$current3.children) || [];
    var updatedEntries = {};
    var _iterator = _createForOfIteratorHelper(containerChildren),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        var targetId = child.getAttribute('data-index');
        if (targetId) {
          updatedEntries[targetId] = parseInt(targetId, 10) < truncateAfter;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    setVisibilityMap(updatedEntries);
  }, []);
  var openOverflowOverlay = React__default.useCallback(function () {
    return setIsOverflowShown(true);
  }, [setIsOverflowShown]);
  var closeOverflowOverlay = React__default.useCallback(function () {
    setIsOverflowShown(false);
  }, [setIsOverflowShown]);
  var collapseInlineExpandedChildren = React__default.useCallback(function () {
    setIsOverflowShown(false);
    if (visibleChildCount && typeof visibleChildCount === 'number') {
      hideChildrenAfterIndex(visibleChildCount);
    }

    // We need to manually re-focus the collapse button if we're not showing the full
    // list in an overlay.
    // TODO: get rid of this hack
    setTimeout(function () {
      var _expandButtonRef$curr;
      // @ts-ignore you can set `.current` on ref objects or ref callbacks in React
      (_expandButtonRef$curr = expandButtonRef.current) === null || _expandButtonRef$curr === void 0 ? void 0 : _expandButtonRef$curr.focus();
    }, 10);
  }, [expandButtonRef, hideChildrenAfterIndex, visibleChildCount]);
  var showAllTokensInline = React__default.useCallback(function () {
    setVisibilityMap({});
    setIsOverflowShown(true);
  }, [setVisibilityMap, setIsOverflowShown]);
  React__default.useEffect(function () {
    // If we're not truncating, we don't need to run this useEffect.
    if (!visibleChildCount || isOverflowShown) {
      return;
    }
    if (visibleChildCount === 'auto') {
      // Instatiates the IntersectionObserver to track when children fit in the container.
      var observer = new IntersectionObserver(function (entries) {
        var updatedEntries = {};
        var _iterator2 = _createForOfIteratorHelper(entries),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var entry = _step2.value;
            // Checks which children are intersecting the root container
            var targetId = entry.target.getAttribute('data-index');
            if (targetId) {
              updatedEntries[targetId] = entry.isIntersecting;
            }
          }

          // Updates the visibility map based on the intersection results.
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        setVisibilityMap(function (prev) {
          return _objectSpread(_objectSpread({}, prev), updatedEntries);
        });
      }, {
        root: containerRef.current,
        rootMargin: "0px -".concat(buttonClientRect.width, "px 0px 0px"),
        threshold: 1
      });
      var _iterator3 = _createForOfIteratorHelper(((_containerRef$current4 = containerRef.current) === null || _containerRef$current4 === void 0 ? void 0 : _containerRef$current4.children) || []),
        _step3;
      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var item = _step3.value;
          var _containerRef$current4;
          if (item.getAttribute('data-index')) {
            observer.observe(item);
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
      return function () {
        return observer.disconnect();
      };
    }
    // We're not auto truncating, so we need to hide children after the given `visibleChildCount`.
    else {
      hideChildrenAfterIndex(visibleChildCount);
    }
  }, [buttonClientRect, visibleChildCount, hideChildrenAfterIndex, isOverflowShown]);

  // Updates the index of the first hidden child.
  // We need to keep track of this so we can focus the first hidden child when the overflow is shown inline.
  React__default.useEffect(function () {
    // If we're using an overlay, we don't need to keep track of the first hidden index.
    if (overflowStyle === 'overlay') {
      return;
    }
    if (hiddenItemIds.length) {
      firstHiddenIndexRef.current = parseInt(hiddenItemIds[0], 10);
    }
  }, [hiddenItemIds, overflowStyle, isOverflowShown]);

  // Updates the index of the first hidden child.
  // We need to keep track of this so we can focus the first hidden child when the overflow is shown inline.
  React__default.useEffect(function () {
    // If we're using an overlay, we don't need to focus the first child that was previously hidden.
    if (overflowStyle === 'overlay') {
      return;
    }
    var firstHiddenChildDOM = document.querySelector("[data-index=\"".concat(firstHiddenIndexRef.current, "\"]"));
    var focusableChild = firstHiddenChildDOM ? getFocusableChild(firstHiddenChildDOM) : null;
    if (isOverflowShown) {
      // If the first hidden child is focusable, focus it.
      // Otherwise, focus the collapse button.
      if (focusableChild) {
        focusableChild.focus();
      } else {
        var _collapseButtonRef$cu;
        (_collapseButtonRef$cu = collapseButtonRef.current) === null || _collapseButtonRef$cu === void 0 ? void 0 : _collapseButtonRef$cu.focus();
      }
    }
  }, [overflowStyle, isOverflowShown]);

  // If truncation is enabled, we need to render based on truncation logic.
  return visibleChildCount ? /*#__PURE__*/React__default.createElement(StyledLabelGroupContainer, {
    ref: containerRef,
    "data-overflow": overflowStyle === 'inline' && isOverflowShown ? 'inline' : undefined,
    sx: sxProp
  }, React__default.Children.map(children, function (child, index) {
    return /*#__PURE__*/React__default.createElement(ItemWrapper
    // data-index is used as an identifier we can use in the IntersectionObserver
    , {
      "data-index": index,
      className: hiddenItemIds.includes(index.toString()) ? 'ItemWrapper--hidden' : undefined
    }, child);
  }), overflowStyle === 'inline' ? /*#__PURE__*/React__default.createElement(InlineToggle, {
    collapseButtonRef: collapseButtonRef,
    collapseInlineExpandedChildren: collapseInlineExpandedChildren,
    expandButtonRef: expandButtonRef,
    hiddenItemIds: hiddenItemIds,
    isOverflowShown: isOverflowShown,
    showAllTokensInline: showAllTokensInline,
    totalLength: React__default.Children.toArray(children).length
  }) : /*#__PURE__*/React__default.createElement(OverlayToggle, {
    closeOverflowOverlay: closeOverflowOverlay,
    expandButtonRef: expandButtonRef,
    hiddenItemIds: hiddenItemIds,
    isOverflowShown: isOverflowShown,
    openOverflowOverlay: openOverflowOverlay,
    overlayPaddingPx: overlayPaddingPx,
    overlayWidth: overlayWidth,
    totalLength: React__default.Children.toArray(children).length
  }, children)) : /*#__PURE__*/React__default.createElement(StyledLabelGroupContainer, {
    "data-overflow": "inline",
    sx: sxProp
  }, children);
};
LabelGroup.displayName = 'LabelGroup';
var LabelGroup$1 = LabelGroup;
export { LabelGroup$1 as default };